import { useTranslation } from "react-i18next";
import { aboutImages } from "../../utils/data";
import React from "react";

const AboutUslot = () => {
  const { t, i18n } = useTranslation("about");
  const isRTL = i18n.language === "ar";
  return (
    <section className="padding-x md-max:px-6 md-max:py-10 flex flex-col gap-20 md-max:gap-10 mt-10">
      <div className="flex flex-col gap-10 items-center justify-between md-max:gap-5">
        <div className="flex w-[80%] flex-col gap-12 md-max:w-full md-max:gap-3">
          {/* <UseInView translatePosition="X" translateValue="-50px">
            <Badge className="font-phudu bg-yellow text-logo-green w-max rounded-full border border-[#F0F0F0] px-5 py-2.5 text-xl md-max:text-lg">
              About RailRolls
            </Badge>
          </UseInView> */}
          <div>
            <h2 className="text-7xl md-max:text-4xl font-semibold text-center text-[#1C75BC]">
              {t("aboutUslot.title")}
            </h2>
          </div>
        </div>
        <div className="w-[80%] md-max:w-full">
          <p className="text-center">{t("aboutUslot.description")}</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 md-max:grid-cols-1">
        {t("aboutUslot.cards", { returnObjects: true }).map((item, index) => (
          <div
            key={index}
            className={`col-span-1 h-96 relative overflow-hidden rounded-2xl bg-gray-400`}
          >
            <img
              src={item.image}
              alt="Rail Rolls"
              width={1000}
              height={1000}
              className="h-full w-full object-cover"
            />
            <div className="from-[#064C99] absolute bottom-0 h-full w-full bg-gradient-to-t to-transparent"></div>
            <div className={`absolute bottom-5 ${isRTL ? "right-5" : "left-5"} flex w-full flex-col gap-2`}>
              <p className="text-2xl font-bold text-white">{item.title}</p>
              <p className="text-base max-w-[90%] text-white">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutUslot;
